export type ConjunctionConst = 'AND' | 'OR';
export type Conjunctions = Conjunction[];
export type Conjunction = { name: ConjunctionConst; label: ConjunctionConst };

export const defaultConjunctions: Conjunctions = [
  { name: 'AND', label: 'AND' },
  { name: 'OR', label: 'OR' },
];
